import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TermsPrivacyDialogComponent } from '@components/terms/terms-privacy-dialog/terms-privacy-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TermsAndConditionsComponent {
  protected dialog = inject(MatDialog);

  

  /**
   * Open 'Terms & privacy' dialog
   */
  openTermsPrivacyDialog(): void {
    this.dialog.open(TermsPrivacyDialogComponent);
  }
}
